import { useState, useMemo } from "react";
import PropTypes from "prop-types";
import Modal from "../common/Modal";
import { useUserHomeSelect } from "../../hooks/useUserHomeSelect";
import { getUserTypeLabel, USER_TYPES, FILTER_STATUS } from "../../utils";

export default function UserSelectorModal({ isOpen, onClose }) {
  const { activeUsers, loading, selectUser } = useUserHomeSelect();
  const [userTypeFilter, setUserTypeFilter] = useState(FILTER_STATUS.ALL);

  // Filtre les users selon le userTypeFilter
  const filteredUsers = useMemo(() => {
    if (userTypeFilter === FILTER_STATUS.ALL) return activeUsers;
    return activeUsers.filter((u) => u.user_type === userTypeFilter);
  }, [activeUsers, userTypeFilter]);

  const handleSelectUser = (user) => {
    selectUser(user);
    onClose();
  };

  // Generate filter pills dynamically
  const filterOptions = useMemo(() => {
    const types = Object.values(USER_TYPES);
    return [FILTER_STATUS.ALL, ...types];
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Sélectionnez votre profil"
      size="md"
    >
      <div className="user-selector-content">
        {loading ? (
          <div className="loading">
            <div className="loading-spinner" />
            <p>Chargement des utilisateurs...</p>
          </div>
        ) : (
          <>
            {/* Filters */}
            {activeUsers.length > 0 && (
              <div className="user-selector-filters">
                <div className="filter-pills">
                  {filterOptions.map((type) => (
                    <button
                      key={type}
                      type="button"
                      className={`pill ${userTypeFilter === type ? "pill-active" : ""}`}
                      onClick={() => setUserTypeFilter(type)}
                    >
                      {type === FILTER_STATUS.ALL
                        ? "Tous"
                        : getUserTypeLabel(type)}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Simple User List */}
            <div className="user-selector-list">
              {filteredUsers.length > 0 ? (
                <ul className="user-list">
                  {filteredUsers.map((user) => (
                    <li
                      key={user.id}
                      className="user-list-item"
                      onClick={() => handleSelectUser(user)}
                    >
                      <span className="user-name">
                        {user.first_name} {user.last_name}
                      </span>
                      <span className="user-type">
                        {getUserTypeLabel(user.user_type)}
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="empty-state-small">
                  <p>Aucun utilisateur correspondant au filtre.</p>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

UserSelectorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
